<template>
  <v-container>
    <v-card class="q mb-5" v-for="(q, i) in qas" :key="i" color="#dfdfdf">
      <v-card-title>{{ q.title }}</v-card-title>
      <v-card-subtitle>{{ q.author }}</v-card-subtitle>
      <v-card-text>
        {{ q.body }}
        <v-row v-if="q.votes.length">
          <v-col cols="12" sm="6">
            <ul>
              <li>
                <strong>{{ $t("customer.admin.votes.total") }}</strong> {{ q.votes.length }}
              </li>
              <li>
                <strong>{{ $t("customer.votes.yes") }}</strong> {{ voteCount(q.votes, 1) }}
              </li>
              <li>
                <strong>{{ $t("customer.votes.no") }}</strong> {{ voteCount(q.votes, -1) }}
              </li>
              <li>
                <strong>{{ $t("customer.votes.abstention") }}</strong> {{ voteCount(q.votes, 0) }}
              </li>
            </ul>

            <v-expansion-panels v-model="q.panel" flat>
              <v-expansion-panel>
                <v-expansion-panel-header color="#efefef">{{ $t("customer.admin.votes.details") }}</v-expansion-panel-header>
                <v-expansion-panel-content color="#efefef">
                  <ul>
                    <li v-for="(v, i) in q.votes" :key="i">{{ v.voter.name }} - {{ getVoteString(v.vote) }}</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <v-col cols="12" sm="6">
            <vc-donut :sections="donutConfig(q.votes)" has-legend legend-placement="top" :size="200" unit="px" :thickness="100"></vc-donut>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="canDelete">
        <v-switch v-model="q.state" :label="$t('customer.admin.votes.state')" value="active" @change="setState(q.id, q.state)"></v-switch>
        <v-spacer></v-spacer>
        <v-btn dark @click="delQuestion(q.id)" color="primary">{{ $t("common.actions.delete") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

import { formatMixin, formMixin, listMixin } from "@/helpers/mixins";

export default {
  name: "questionlist",

  mixins: [formatMixin, formMixin, listMixin],

  components: [],

  data() {
    return {
      sections: [{ value: 25 }, { value: 25 }],
      panel: []
    };
  },

  props: {
    qas: {
      type: Array,
    },
    canDelete: {
      type: Boolean,
    },
    type: {
      type: String,
      default: "question",
    },
    onChange: {
      type: Function,
    },
  },
  computed: {},
  mounted() {},
  methods: {
    getVoteString: function(v) {
      let val = this.$i18n.t("customer.votes.abstention");
      switch (v) {
        case 1:
          val = this.$i18n.t("customer.votes.yes");
          break;

        case -1:
          val = this.$i18n.t("customer.votes.no");
          break;
      }

      return val;
    },
    donutConfig: function(votes) {
      return [
        { label: "Ja", value: (this.voteCount(votes, 1) * 100) / votes.length, color: "green" },
        { label: "Nein", value: (this.voteCount(votes, -1) * 100) / votes.length, color: "red" },
        { label: "Enthalten", value: (this.voteCount(votes, 0) * 100) / votes.length, color: "silver" },
      ];
    },
    voteCount: function(votes, type) {
      return votes.filter((v) => v.vote == type).length;
    },
    setState: function(id, state) {
      if (id) {
        axios
          .post(`/api/questions/${id}`, { state: state == "active" ? "active" : "inactive" })
          .then(() => {
            this.onChange();
          })
          .catch(() => {});
      }
    },
    delQuestion: function(id) {
      axios
        .delete(`/api/questions/${id}`)
        .then(() => {
          this.onChange();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped></style>
